import { IncomeRepresentation } from "src/app/api/smart-pensjon-rest-api/models";
import { MockScenario } from "../mock-scenario";

/**
 * With all consents the salary comes from the employer, so the onboarding popup doesn't open and the salary step
 * shows the employer choice. Without them there is no salary yet, so the popup opens with the salary step and the
 * user types it in.
 */
export const generateMockIncome = (scenario: MockScenario): { payload: IncomeRepresentation } => {
  if (scenario.hasAllConsents) {
    return {
      payload: {
        annualSalary: 650000,
        employerSalary: 650000,
        hasActivePublicPensionContract: false,
        source: "EMPLOYER",
        errors: null,
      },
    };
  }

  return {
    payload: {
      annualSalary: null,
      employerSalary: null,
      hasActivePublicPensionContract: false,
      source: null,
      errors: null,
    },
  };
};
